import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

const TOAST_OPTIONS = {
  style: {
    background: "#0B1120",
    color: "#F8FAFC",
    border: "1px solid rgba(6, 182, 212, 0.4)",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
